interface ViewProps {
    selectedDate: Date;
    appointments: any[];
    clientsById: Map<string, any>;
    barbersById: Map<string, any>;
    onDayClick?: (date: Date) => void;
    onAppointmentClick?: (appointment: any) => void;
    getBarberColors?: (barberId: string, status: string) => string;
}

export default function MonthView({
    selectedDate,
    appointments,
    clientsById: _clientsById,
    barbersById: _barbersById,
    onDayClick,
    onAppointmentClick,
    getBarberColors: _getBarberColors,
}: ViewProps) {
    const getDaysInMonth = (date: Date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDay = new Date(year, month, 1);
        const startDate = new Date(firstDay);
        startDate.setDate(startDate.getDate() - firstDay.getDay());

        const days = [] as Array<Date>;
        const current = new Date(startDate);

        for (let i = 0; i < 42; i++) {
            days.push(new Date(current));
            current.setDate(current.getDate() + 1);
        }

        return days;
    };

    const days = getDaysInMonth(selectedDate);
    const today = new Date();
    const isToday = (date: Date) =>
        date.toDateString() === today.toDateString();
    const isCurrentMonth = (date: Date) =>
        date.getMonth() === selectedDate.getMonth();

    const getApptsForDay = (date: Date) => {
        const dayStart = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
        ).getTime();
        const dayEnd = dayStart + 24 * 60 * 60 * 1000;
        return appointments.filter(
            (a) => a.startTime >= dayStart && a.startTime < dayEnd,
        );
    };

    return (
        <div>
            <div className="px-3 py-2 border-b border-gray-200/50 dark:border-gray-700/50 bg-gradient-to-r from-gray-50 to-blue-50/30 dark:from-gray-800 dark:to-blue-900/10">
                <div className="grid grid-cols-7 gap-1">
                    {["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"].map(
                        (day) => (
                            <div
                                key={day}
                                className="p-1 text-center text-xs font-bold text-gray-600 dark:text-gray-400"
                            >
                                {day}
                            </div>
                        ),
                    )}
                </div>
            </div>
            <div className="p-4">
                <div className="grid grid-cols-7 gap-2">
                    {days.map((day, index) => {
                        const dayAppts = getApptsForDay(day);
                        const isCurrentDay = isToday(day);
                        const isThisMonth = isCurrentMonth(day);

                        return (
                            <div
                                key={index}
                                onClick={() => onDayClick?.(day)}
                                className={`h-[90px] p-2 border rounded-lg cursor-pointer transition-colors duration-200 group relative flex flex-col overflow-hidden ${
                                    isCurrentDay
                                        ? "bg-gradient-to-br from-emerald-100 via-emerald-50 to-teal-50 dark:from-emerald-800/40 dark:via-emerald-900/30 dark:to-teal-900/30 border-emerald-400 dark:border-emerald-500 ring-2 ring-emerald-300 dark:ring-emerald-600"
                                        : isThisMonth
                                          ? "bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 hover:bg-gradient-to-br hover:from-emerald-50 hover:to-blue-50 dark:hover:from-emerald-900/10 dark:hover:to-blue-900/10 hover:border-emerald-200 dark:hover:border-emerald-700"
                                          : "bg-gray-50/70 dark:bg-gray-700/30 border-gray-200/50 dark:border-gray-600/50 hover:bg-gray-100/80 dark:hover:bg-gray-600/40"
                                }`}
                            >
                                <div className="flex items-center justify-between mb-2">
                                    <div
                                        className={`text-base font-black relative ${
                                            isCurrentDay
                                                ? "text-emerald-800 dark:text-emerald-200"
                                                : isThisMonth
                                                  ? "text-gray-900 dark:text-white"
                                                  : "text-gray-400 dark:text-gray-500"
                                        }`}
                                    >
                                        <span className="relative z-10">
                                            {day.getDate()}
                                        </span>
                                    </div>
                                    {dayAppts.length > 0 && (
                                        <div
                                            className={`text-xs font-bold px-2 py-1 rounded-full ${
                                                isCurrentDay
                                                    ? "bg-emerald-100 dark:bg-emerald-800 text-emerald-700 dark:text-emerald-200"
                                                    : "bg-blue-100 dark:bg-blue-800 text-blue-700 dark:text-blue-200"
                                            }`}
                                        >
                                            {dayAppts.length}
                                        </div>
                                    )}
                                </div>
                                <div className="flex-1 flex flex-col gap-1 overflow-y-auto max-h-12 scrollbar-thin scrollbar-thumb-emerald-300 scrollbar-track-transparent hover:scrollbar-thumb-emerald-400">
                                    {dayAppts.map((appt, i) => {
                                        return (
                                            <div
                                                key={i}
                                                className="text-[10px] leading-4 px-1.5 py-0.5 rounded-md border bg-emerald-50 dark:bg-emerald-900/20 text-emerald-800 dark:text-emerald-200 border-emerald-200 dark:border-emerald-700 truncate cursor-pointer"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onAppointmentClick?.(appt);
                                                }}
                                            >
                                                {new Date(
                                                    appt.startTime,
                                                ).toLocaleTimeString("pt-BR", {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                })}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
